import { render, staticRenderFns } from "./T1DirectionGroupItemFooter.vue?vue&type=template&id=d5635316&"
import script from "./T1DirectionGroupItemFooter.vue?vue&type=script&lang=js&"
export * from "./T1DirectionGroupItemFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports